/* eslint-disable */

import { useState, useEffect, useRef, Suspense, useCallback, useContext, KeyboardEvent } from "react";
import {
	TextField,
	Paper,
	Grid,
	Button,
	Select,
	MenuItem,
	Tooltip,
	Chip,
	Checkbox,
	CheckboxProps
} from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { green } from "@material-ui/core/colors";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import UIContext from "../../../../../../contexts/UIContext/UIContext";
import { useLocation } from "react-router-dom";
import { useQuery } from "../../../../../../hooks";
import { api } from "../../../../../../utils/api";
import AuthContext from "../../../../../../contexts/authContext/authContext";
import { SnackbarAPI } from "../../../../../shared";
import { useDebouncedCallback } from "use-debounce";
import { trackPromise } from "react-promise-tracker";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../constants/caption/dashboardHeader";
import validateEmail from "../../../../../../utils/commonFunctions/validateEmail";
import { SnackbarCloseReason } from "@material-ui/core";

import ROLES from "../../../../../../constants/roles";
import STATES from "../../../../../../constants/states";
import { RELATIONSHIP, RELATIONSHIPS } from "../../../../../../constants/relationships";
import { EVENT_NAME, EVENT_NAMES } from "../../../../../../constants/eventNames";
import GENDERS from "../../../../../../constants/genders";
import DEPENDENT_TYPES from "../../../../../../constants/dependentTypes";
import CONTACT_LABELS from "../../../../../../constants/contactLabels";
import { dependentTypes } from "../../../../../../@types/components/dependent.types";
import { SnackbarProps } from "../../../../../../@types/snackbarAPI.types";
import { Validation } from "../../../../../../@types/validation.types";
import { dependentFormField } from "../../../../../../@types/components/dependentFormField.types";
import { MemberTypes } from "../../../../../../@types/components/member.types";

import PersonAddIcon from "@material-ui/icons/PersonAdd";
import WcIcon from "@material-ui/icons/Wc";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import EventIcon from "@material-ui/icons/Event";
import PublishIcon from "@material-ui/icons/Publish";

import downloadFile from "../../../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../../../utils/commonFunctions/shortenFileName";

import "../../../../../../globalStyles/paperFormStyles.css";
import { findByPlaceholderText } from "@testing-library/react";
import initCapitalize from "../../../../../../utils/commonFunctions/initCapitalize";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import ExtractRouteParams from "../../../../../../utils/commonFunctions/extractRouteParams";
import { DynamicForm, DynamicFormField } from "../../../../../../@types/dynamicForm.types";
import { Member } from "../../../../../../@types/member.types";
import SSNExistsModal from "../createEmployee/existsMemberModel.tsx/ExistMemberModel";
import ExistsOwnMemberModel from "../createEmployee/existsMemberModel.tsx/ExistsMemberOwnModel";
import { GroupContext } from "../../../../../../contexts";
import { relationshipToDependentNumber } from "../../../../../../constants/alternateID/alternateID";
import ExistsDependentModel from "../../../../../shared/existsMemberModel/ExistsDependentModel";
import IdentityConflictModal from "../createEmployee/existsMemberModel.tsx/IdentityConflictModal";
import DependentAlreadyExistsModal from "../createEmployee/existsMemberModel.tsx/DependentAlreadyExistsModal";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import AltIdExistsModal from "../createEmployee/existsMemberModel.tsx/AltIdExistsModal";
import IdentityPersonConversionExistsModal from "../createEmployee/existsMemberModel.tsx/ExistMemberModel";
import ExistDependentAllowingModal from "../createEmployee/existsMemberModel.tsx/ExistDependentAllowingModal";
const date = new Date();
const maxDateRange = date.setDate(date.getDate());

const mailformat = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

type DuplicateCheckMode = "NONE" | "IDENTITY_CONFLICT" | "DEPENDENT_ALREADY_EXISTS";

const CreateDependent = (): JSX.Element => {
	const [dependentForm, setDependentForm] = useState<DynamicForm>();
	const { user } = useContext(AuthContext); // Extracting logged in user from Central storage.
	const [assignedGroups, setAssignedGroups] = useState([]);
	const [assignedLocations, setAssignedLocations] = useState([]);
	const [selectedGroup, setSelectedGroup] = useState<any>();
	const [selectedLocation, setSelectedLocation] = useState<any>();
	const { setDashboardHeader } = useContext(UIContext);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isValidEmployeeId, setIsValidEmployeeId] = useState<boolean>(true);
	const [hasSpouse, setHasSpouse] = useState<boolean>(false); // This value will feed from getEmployee api
	const [isEnrollment, setIsEnrollment] = useState<boolean>(false); // This field is only for Yearly open enrollment.
	const [emailExists, setEmailExists] = useState<boolean>(false);
	const [checkInvalidEmail, setCheckInvalidEmail] = useState<boolean>(false);
	const [pasted, setPasted] = useState<boolean>(false);
	const [hasCreateClick, setHasCreateClick] = useState<boolean>(false);
	const location = useLocation();
	const query = useQuery();
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const { currentGroup } = useContext(GroupContext);
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const [isView, setIsView] = useState<boolean>(false);
	const [memberIdExists, setMemberIdExists] = useState<boolean>(false);
	const [SSNExists, setSSNExists] = useState<boolean>(false);
	const [existMember, setExistMember] = useState<Member>();
	const [showModal, setShowModal] = useState(false);
	const [ownSSNCheck, setOwnSSNCheck] = useState(false);

	const [ssnProvidedByGroup, setSsnProvidedByGroup] = useState<boolean>(false);
	const [showTooltip, setShowTooltip] = useState(false);
	// const [personExists, setPersonExists] = useState(false);
	// const [personRelationships, setPersonRelationships] = useState<any[]>([]);
	// const [showPersonExistsModal, setShowPersonExistsModal] = useState(false);
	const [showIdentityConflictModal, setShowIdentityConflictModal] = useState(false);
	const [identityConflictMemberData, setIdentityConflictMemberData] = useState<any>(null);
	const [altIdForPayload, setAltIdForPayload] = useState<string>("");
	const [conflictAltId, setConflictAltId] = useState<string>("");
	const [duplicateMode, setDuplicateMode] = useState<DuplicateCheckMode>("NONE");
	const [existDependentAllowingModalOpen, setExistDependentAllowingModalOpen] = useState(false);
	const [existingDependentForAllowing, setExistingDependentForAllowing] = useState<any>(null);
	// const [showDependentExistsModal, setShowDependentExistsModal] = useState(false);
	const [existingDependentPerson, setExistingDependentPerson] = useState<any>(null);

	const [altIdModalOpen, setAltIdModalOpen] = useState(false);
	const [existingAltId, setExistingAltId] = useState<string>("");

	const [showDuplicateModal, setShowDuplicateModal] = useState(false);

	const isDuplicateBlocking = duplicateMode === "IDENTITY_CONFLICT" || duplicateMode === "DEPENDENT_ALREADY_EXISTS";

	const [employee, setEmployee] = useState({
		member_id: "",
		employee_SSN: "",
		group_number: null,
		location_number: null,
		first_name: "",
		last_name: ""
	});
	const [dependent, setDependent] = useState<dependentTypes>({
		first_name: "",
		middle_name: "",
		last_name: "",
		email: "",
		SSN: "",
		alt_id: "",
		date_of_birth: "",
		actual_SSN: "",
		gender: "",
		dependent_type: "",
		relationship: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state: "",
		country: "USA - United States of America",
		ZIP: "",
		contact_label: "",
		phone_number: null,
		phone_extension: null,
		event_date: "",
		event_name: "",
		event_document: null,
		is_tobacco: false,
		is_disabled: false,
		dependent_profile_access: true
	});
	const [reEnterSSN, setReEnterSSN] = useState("");
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (
			event: React.SyntheticEvent<Element, Event> | Event | React.SyntheticEvent<any, Event>,
			reason?: SnackbarCloseReason | undefined
		) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const [validation, setValidation] = useState<Validation>({
		dependent: {},
		reEnterSSN: "",
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const navigate = useNavigate();

	const findMemberEmail = useDebouncedCallback(async (value) => {
		if (value !== "") {
			const email = false; //await api.find.findMemberEmail(value);
			if (email === false) {
				setEmailExists(false);
			} else {
				//setEmailExists(true);
			}
		} else {
			setEmailExists(false);
		}
	}, 500);

	const handleKeyCheck = useCallback(
		(event: React.KeyboardEvent<HTMLDivElement>) => {
			let { name, value } = event.target as HTMLInputElement;
			const eventKey = event.key;

			if (name === "ZIP") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index + 1);
						setDependent(Object.assign({}, dependent, { [name]: value }));
					}
				}
			}
			if (name === "SSN") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 4) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setDependent(Object.assign({}, dependent, { [name]: value }));
					}
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.lastIndexOf("-");
						value = value.substring(0, index);
						setDependent(Object.assign({}, dependent, { [name]: value }));
					}
				}
			}
			if (name === "re_enter_SSN") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 4) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setReEnterSSN(value);
					}
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.lastIndexOf("-");
						value = value.substring(0, index);
						setReEnterSSN(value);
					}
				}
			}
		},
		[dependent]
	);

	const checkPersonExists = useDebouncedCallback(async () => {
		if (!dependent.first_name || !dependent.date_of_birth) return;

		try {
			const response = (await api.find.checkPersonAlreadyExists({
				first_name: dependent.first_name,
				last_name: dependent.last_name || "",
				date_of_birth: dependent.date_of_birth,
				employee_SSN: employee.employee_SSN,
				group_number: employee.group_number
			})) as {
				personExists: boolean;
				dependentAlreadyExistsForEmployee?: boolean;
				person?: {
					first_name?: string;
					last_name?: string;
					date_of_birth?: string;
					relationship?: string;
					role?: string;
				};
				relationships?: any[];
			};

			// 🔹 No conflict at all
			if (!response?.personExists) {
				setDuplicateMode("NONE");
				return;
			}

			const person = response.person || {};

			// Store common person info (used by both modals)
			setExistingDependentPerson({
				first_name: person.first_name,
				last_name: person.last_name,
				date_of_birth: person.date_of_birth,
				relationship: person.relationship,
				role: person.role
			});

			//  CASE 1: Dependent already exists for SAME employee
			if (response.dependentAlreadyExistsForEmployee) {
				setDuplicateMode("DEPENDENT_ALREADY_EXISTS");
				setShowDuplicateModal(true);
				return;
			}

			// ⚠️ CASE 2: Person exists but linked elsewhere
			setDuplicateMode("IDENTITY_CONFLICT");
		} catch (error) {
			console.error("[checkPersonExists]", error);
		}
	}, 600);

	const handlePaste = useDebouncedCallback((event: React.ClipboardEvent<HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;
		if (name === "SSN" || name === "ZIP" || name === "re_enter_SSN") {
			setPasted(true);
		}
	}, 2000);

	const handleReEnterSSNChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			let { value } = event.target;

			if (!pasted) {
				const _value = Number(value.replaceAll("-", ""));
				if (!isNaN(_value as any)) {
					let ssn = value;
					if (
						!(
							/^[0-9]{0,3}$/.test(value) ||
							/^[0-9]{3}-[0-9]{0,2}$/.test(value) ||
							/^[0-9]{3}-[0-9]{2}-[0-9]{0,4}$/.test(value)
						)
					) {
						// value = value.substr(0, ssn.length - 1);
						ssn = ssn.substring(0, ssn.length - 1);
					} else if (ssn.length === 6) {
						ssn = ssn.substring(0, 7) + "-" + ssn.substring(7);
					} else if (ssn.length === 3) {
						// value = value.substr(0, 3) + "-" + value.substr(3);
						ssn = ssn.substring(0, 3) + "-" + ssn.substring(3);
					}
					setReEnterSSN(ssn);
				} else {
					event.target.value = "";
					event.target.value = reEnterSSN;
				}
			} else {
				// console.log("Pasted");
				setPasted(false);
				if (!isNaN(value as any)) {
					if (value.length > 9) {
						event.target.value = "";
						event.target.value = reEnterSSN;
						alert("Please enter a valid 9 digit SSN!");
					} else {
						// console.log("Inside Number");
						const ssn = value;

						if (ssn.length === 4) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						} else if (ssn.length === 5) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						} else if (ssn.length >= 6 && ssn.length <= 9) {
							value = value.substring(0, 3) + "-" + value.substring(3, 2) + "-" + value.substring(5);
						}
						setReEnterSSN(value);
					}
				} else {
					// console.log("Inside alpha-numeric");
					let ssnValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
					//console.log("replaced string", ssnValue);
					alert("You have pasted alpha-numeric SSN!");

					if (ssnValue.length > 9) {
						event.target.value = "";
						event.target.value = reEnterSSN as unknown as string;
						alert("Please enter a valid SSN!");
					} else {
						const ssn = ssnValue;

						if (ssn.length === 4) {
							ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
						} else if (ssn.length === 5) {
							ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
						} else if (ssn.length >= 6 && ssn.length <= 9) {
							ssnValue =
								ssnValue.substring(0, 3) + "-" + ssnValue.substring(3, 2) + "-" + ssnValue.substr(5);
						}

						setReEnterSSN(ssnValue);
					}
				}
			}
		},
		[pasted, reEnterSSN]
	);

	const findMemberSSN = useDebouncedCallback(async (value: string) => {
		if (value !== "") {
			const findSSNQuery = {
				group_number: employee.group_number,
				SSN: value
			};
			try {
				const SSN = await api.find.findMemberSSN(findSSNQuery);
				if (SSN === false) {
					setSSNExists(false);
					setExistMember(undefined);
				} else {
					setSSNExists(true);
					setExistMember(SSN);

					// ADD: Check if it's a DEPENDENT and different employee
					if (SSN.role === "DEPENDENT") {
						// Check if this dependent belongs to a different employee
						const isDifferentEmployee = SSN.employee_SSN !== employee.employee_SSN?.replace(/-/g, "");

						if (isDifferentEmployee) {
							setExistingDependentForAllowing(SSN);
							setExistDependentAllowingModalOpen(true);
							return; // Don't open default modal
						}
					}

					setIsModalOpen(true); // Default modal for other cases
				}
			} catch (error) {
				console.error("Error finding SSN:", error);
				setExistMember(undefined);
			}
		} else {
			setSSNExists(false);
			setExistMember(undefined);
		}
	}, 500);

	const handleAllowExistingDependent = useCallback(() => {
		// Set the SSN without suffix for payload (indicates existing dependent)
		const ssnWithoutSuffix = existingDependentForAllowing.SSN;
		setAltIdForPayload(ssnWithoutSuffix);

		// Close modal
		setExistDependentAllowingModalOpen(false);

		// Optionally auto-fill or just proceed
		// The user can now click "Create Dependent"
	}, [existingDependentForAllowing]);
	const handleDependentChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			let { name, value } = event.target;

			if (name === "first_name") {
				const regex = /^[a-zA-Z\s',.]+$/g;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setDependent({ ...dependent, [name]: value });
				}
				setTimeout(checkPersonExists, 0);
			} else if (name === "relationship") {
				if (
					dependent.event_name === EVENT_NAME.birth_of_baby &&
					(value === RELATIONSHIP.stepchild ||
						value === RELATIONSHIP.disabled_child ||
						value === RELATIONSHIP.legal_custody_child ||
						value === RELATIONSHIP.court_ordered_dependent)
				)
					dependent.event_name = "";
				else if (
					(dependent.event_name === EVENT_NAME.adoption || dependent.event_name === EVENT_NAME.others) &&
					(value === RELATIONSHIP.child || value === RELATIONSHIP.grandchild)
				)
					dependent.event_name = "";
				else if (
					dependent.event_name === EVENT_NAME.marriage &&
					(value === RELATIONSHIP.child ||
						value === RELATIONSHIP.grandchild ||
						value === RELATIONSHIP.stepchild ||
						value === RELATIONSHIP.disabled_child ||
						value === RELATIONSHIP.legal_custody_child ||
						value === RELATIONSHIP.court_ordered_dependent)
				)
					dependent.event_name = "";
				else if (
					(dependent.event_name === EVENT_NAME.adoption ||
						dependent.event_name === EVENT_NAME.others ||
						dependent.event_name === EVENT_NAME.birth_of_baby) &&
					value === RELATIONSHIP.spouse
				)
					dependent.event_name = "";

				setDependent(Object.assign({}, dependent, { [name]: value }));
			} else if (name === "email") {
				// findMemberEmail(value);

				setDependent(Object.assign({}, dependent, { [name]: value }));
			} else if (name === "SSN") {
				const _ssn = value.replaceAll("-", "");
				findMemberSSN(_ssn);
				if (!pasted) {
					// console.log("Not Pasted");
					var _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value)) {
						let ssn = value;
						if (
							!(
								/^[0-9]{0,3}$/.test(value) ||
								/^[0-9]{3}-[0-9]{0,2}$/.test(value) ||
								/^[0-9]{3}-[0-9]{2}-[0-9]{0,4}$/.test(value)
							)
						) {
							value = value.substring(0, value.length - 1);
						} else if (ssn.length === 6) {
							value = value.substring(0, 7) + "-" + value.substring(7);
						} else if (ssn.length === 3) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						}

						setDependent(Object.assign({}, dependent, { [name]: value }));
					} else {
						event.target.value = "";
						if (dependent.SSN) {
							event.target.value = dependent.SSN?.toString();
						}
					}
				} else {
					// console.log("Pasted");
					setPasted(false);
					if (!isNaN(Number(value))) {
						if (value.length > 9) {
							event.target.value = "";
							if (dependent.SSN) {
								event.target.value = dependent.SSN?.toString();
							}
							alert("Please enter a valid 9 digit SSN!");
						} else {
							// console.log("Inside Number");
							let ssn = value;

							if (ssn.length === 4) {
								value = value.substring(0, 3) + "-" + value.substring(3);
							} else if (ssn.length === 5) {
								value = value.substring(0, 3) + "-" + value.substring(3);
							} else if (ssn.length >= 6 && ssn.length <= 9) {
								value = value.substring(0, 3) + "-" + value.substring(3, 5) + "-" + value.substring(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						if (value.length > 11) {
							event.target.value = "";
							if (dependent.SSN) {
								event.target.value = dependent.SSN?.toString();
							}
							alert("Please enter a valid 9 digit SSN!");
						} else if (!/^[0-9-]$/.test(value)) {
							event.target.value = "";
							if (dependent.SSN) {
								event.target.value = dependent.SSN?.toString();
							}
							alert("Please enter a valid 9 digit SSN!");
						} else {
							var ssnValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
							//console.log("replaced string", ssnValue);
							alert("You have pasted alpha-numeric SSN!");

							if (ssnValue.length > 9) {
								event.target.value = "";
								if (dependent.SSN) {
									event.target.value = dependent.SSN?.toString();
								}
								alert("Please enter a valid SSN!");
							} else {
								let ssn = ssnValue;

								if (ssn.length === 4) {
									ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
								} else if (ssn.length === 5) {
									ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
								} else if (ssn.length >= 6 && ssn.length <= 9) {
									ssnValue =
										ssnValue.substring(0, 3) +
										"-" +
										ssnValue.substring(3, 5) +
										"-" +
										ssnValue.substring(5);
								}

								setDependent(Object.assign({}, dependent, { [name]: ssnValue }));
							}
						}
					}
				}
			} else if (name === "ZIP") {
				if (!pasted) {
					var _value = Number(value.replaceAll("-", ""));
					if (!isNaN(_value) && value.length <= 10) {
						let zip = value;
						if (zip.length === 6) {
							value = value.substring(0, 5) + "-" + value.substring(5);
						}

						// console.log("ZIP Event", event.target.value);
						setDependent(
							Object.assign({}, dependent, {
								[name]: value
							})
						);
					} else {
						event.target.value = "";
						event.target.value = dependent.ZIP;
					}
				} else {
					setPasted(false);
					if (!isNaN(Number(value))) {
						if (value.length > 9) {
							event.target.value = "";
							event.target.value = dependent.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							// console.log("Inside Number");
							let zip = value;

							if (zip.length >= 6 && zip.length <= 9) {
								value = value.substring(0, 5) + "-" + value.substring(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						var zipValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", zipValue);
						alert("You have pasted alpha-numeric ZIP!");

						if (zipValue.length > 9) {
							event.target.value = "";
							event.target.value = dependent.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							let zip = zipValue;

							if (zip.length >= 6 && zip.length <= 9) {
								zipValue = zipValue.substring(0, 5) + "-" + zipValue.substring(5);
							}

							setDependent(Object.assign({}, dependent, { [name]: zipValue }));
						}
					}
				}
			} else if (name === "phone_number") {
				if (!isNaN(value as any)) {
					if (value.length <= 10) {
						setDependent(Object.assign({}, dependent, { [name]: value }));
					} else {
						event.target.value = dependent.phone_number
							? (dependent.phone_number as unknown as string)
							: "";
						alert("Phone Number cannot be greater 10 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = dependent.phone_number ? (dependent.phone_number as unknown as string) : "";
				}
			} else if (name === "phone_extension") {
				if (!isNaN(value as any)) {
					if (value.length <= 3) {
						setDependent(Object.assign({}, dependent, { [name]: value }));
					} else {
						event.target.value = dependent.phone_extension
							? (dependent.phone_extension as unknown as string)
							: "";
						alert("Phone Extension cannot be greater 3 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = dependent.phone_extension
						? (dependent.phone_extension as unknown as string)
						: "";
				}
			} else {
				setDependent(Object.assign({}, dependent, { [name]: value }));
			}
		},
		[dependent, findMemberEmail, pasted]
	);

	const handleDocumentChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { files } = event.target;
			if (files) {
				let _dependent = {
					...dependent,
					event_document: files[0]
					// filename: files[0].name
				};
				//setFileInput(fileInput => ({ ...fileInput, [name]: files[0] }))
				if (
					_dependent.event_document.type === "image/png" ||
					_dependent.event_document.type === "image/jpg" ||
					_dependent.event_document.type === "image/jpeg" ||
					_dependent.event_document.type === "application/pdf"
				) {
					setDependent(Object.assign({}, _dependent));
				} else {
					alert("Invalid file type! Please upload the file of this types (.JPG, .JPEG, .PNG, .PDF)");
				}
				event.target.value = "";
			}
		},
		[dependent]
	);

	useEffect(() => {
		if (selectedGroup?.SSN_provided_by_group === true) {
			setSsnProvidedByGroup(true);
		} else {
			setSsnProvidedByGroup(false);
		}
	}, [selectedGroup]);

	const handleDeleteDocument = useCallback(() => {
		let _dependent = {
			...dependent,
			event_document: null
		};
		setDependent(Object.assign({}, _dependent));
	}, [dependent]);

	// const handleDeleteDocument = () => {
	// 	setDependent({
	// 		...dependent,
	// 		event_document: null
	// 	});
	// };

	const handleValidation = useCallback(async () => {
		const {
			first_name,
			last_name,
			email,
			SSN,
			date_of_birth,
			dependent_type,
			gender,
			relationship,
			address_line_1,
			city,
			state,
			ZIP,
			contact_label,
			phone_number,
			phone_extension,
			event_date,
			event_name,
			event_document
		} = dependent;
		_validation.current = {
			...validation,
			dependent: {},
			reEnterSSN: "",
			status: "invalid"
		};
		let flag = true;

		if (first_name.length === 0) {
			_validation.current.dependent["first_name"] = "First Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (last_name.length === 0) {
			_validation.current.dependent["last_name"] = "Last Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		const isSSNRequired = ssnProvidedByGroup === true || selectedGroup?.SSN_provided_by_group === true;
		// if (isSSNRequired) {
		// 	if (SSN.length === 0) {
		// 		_validation.current.dependent["SSN"] = "SSN is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// 	if (SSN !== null) {
		// 		if (SSN !== "") {
		// 			const _SSN = SSN.replaceAll("-", "");
		// 			if (String(_SSN).length !== 9) {
		// 				_validation.current.dependent["SSN"] = "Enter correct 9 digit SSN";
		// 				_validation.current["status"] = "invalid";
		// 				flag = false;
		// 			}
		// 		}
		// 	}
		// 	if (SSN !== "") {
		// 		const _SSN = SSN.replaceAll("-", "");
		// 		if (String(_SSN).length !== 9) {
		// 			_validation.current.dependent["SSN"] = "Enter correct 9 digit SSN";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// 	if (SSN !== "") {
		// 		if (reEnterSSN === "") {
		// 			_validation.current["reEnterSSN"] = "Re-Enter SSN cannot be Empty, as SSN is Given";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// 	if (SSN !== "") {
		// 		const _SSN = SSN.replaceAll("-", "");
		// 		const _reEnterSSN = reEnterSSN.replaceAll("-", "");
		// 		if (_SSN !== _reEnterSSN) {
		// 			_validation.current["reEnterSSN"] = "Must be same as SSN";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// 	if (reEnterSSN !== "") {
		// 		if (SSN === "") {
		// 			_validation.current.dependent["SSN"] = "SSN cannot be Empty, as Re-Enter SSN is Given";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// }
		if (isSSNRequired) {
			// SSN is required by group
			if (SSN.length === 0) {
				_validation.current.dependent["SSN"] = "SSN is required by group policy";
				_validation.current["status"] = "invalid";
				flag = false;
			}
			if (SSN !== null && SSN !== "") {
				const _SSN = SSN.replaceAll("-", "");
				if (String(_SSN).length !== 9) {
					_validation.current.dependent["SSN"] = "Enter correct 9 digit SSN";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
			if (SSN !== "") {
				if (reEnterSSN === "") {
					_validation.current["reEnterSSN"] = "Re-Enter SSN cannot be Empty, as SSN is Given";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
			if (SSN !== "") {
				const _SSN = SSN.replaceAll("-", "");
				const _reEnterSSN = reEnterSSN.replaceAll("-", "");
				if (_SSN !== _reEnterSSN) {
					_validation.current["reEnterSSN"] = "Must be same as SSN";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
			if (reEnterSSN !== "") {
				if (SSN === "") {
					_validation.current.dependent["SSN"] = "SSN cannot be Empty, as Re-Enter SSN is Given";
					_validation.current["status"] = "invalid";
					flag = false;
				}
			}
		} else {
			// ALT ID mode - either SSN or ALT ID must be provided
			const cleanSSN = SSN.replaceAll("-", "");
			const hasSSN = cleanSSN.length === 9;
			const hasAltId = dependent.alt_id && dependent.alt_id.length > 0;

			if (!hasSSN && !hasAltId) {
				_validation.current.dependent["alt_id"] = "Either SSN or ALT ID is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}

			// Only validate SSN format if SSN is provided (optional field in ALT ID mode)
			if (cleanSSN.length > 0 && cleanSSN.length !== 9) {
				_validation.current.dependent["SSN"] = "Enter correct 9 digit SSN";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (String(date_of_birth).length === 0) {
			_validation.current.dependent["date_of_birth"] = "Date of birth is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (gender.length === 0) {
			_validation.current.dependent["gender"] = "Gender is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (contact_label.length === 0) {
			_validation.current.dependent["contact_label"] = "Contact Label is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		// if (email.length === 0) {
		// 	_validation.current.dependent["email"] = "Email is required";
		// 	_validation.current["status"] = "invalid";
		// 	flag = false;
		// }
		if (email.length !== 0) {
			if (!email.match(mailformat)) {
				_validation.current.dependent["email"] = "Valid Email is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
			setCheckInvalidEmail(false);
			if (!validateEmail(email)) {
				setCheckInvalidEmail(true);
			}
		}
		if (relationship.length === 0) {
			_validation.current.dependent["relationship"] = "Relationship is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (dependent_type.length === 0) {
			_validation.current.dependent["dependent_type"] = "Dependent Type is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		// if (phone_number === null) {
		// 	_validation.current.dependent["phone_number"] = "Phone number is required";
		// 	_validation.current["status"] = "invalid";
		// 	flag = false;
		// }
		// if (phone_number !== null) {
		// 	if (String(phone_number) !== "") {
		// 		if (String(phone_number).length !== 10) {
		// 			_validation.current.dependent["phone_number"] = "Enter valid 10 digit phone number";
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 		}
		// 	}
		// }
		// // if (phone_extension === null) {
		// 	_validation.current.dependent["phone_extension"] = "Phone extension is required";
		// 	_validation.current["status"] = "invalid";
		// 	flag = false;
		// }
		// if (phone_extension !== null) {
		// 	if (String(phone_extension).length > 3) {
		// 		_validation.current.dependent["phone_extension"] = "Enter Valid 3 digit Phone extension";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		if (address_line_1.length === 0) {
			_validation.current.dependent["address_line_1"] = "Address line 1 is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (city.length === 0) {
			_validation.current.dependent["city"] = "City is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (state.length === 0) {
			_validation.current.dependent["state"] = "State is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length === 0) {
			_validation.current.dependent["ZIP"] = "ZIP Code is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (ZIP.length !== 0) {
			const _zip = ZIP.replaceAll("-", "");
			if (_zip.length !== 5 && _zip.length !== 9) {
				_validation.current.dependent["ZIP"] = "Enter 5 or 9 digit ZIP Code!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// if (!isEnrollment) {
		// 	if (String(event_date).length === 0) {
		// 		_validation.current.dependent["event_date"] = "Event Date is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// 	if (event_name?.length === 0) {
		// 		_validation.current.dependent["event_name"] = "Event name is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// 	if (event_document === null) {
		// 		_validation.current.dependent["event_document"] = "Event document is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required Family Member details!");
		}

		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [dependent, isEnrollment, reEnterSSN, validation, ssnProvidedByGroup, selectedGroup, altIdForPayload]);

	const handleDependentDateChange = useCallback(
		(_date: Date, name: string) => {
			const date = new Date(_date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			setDependent(Object.assign({}, dependent, { [name]: parsedDate }));
		},
		[dependent]
	);
	// const handleDependentDateChange = useCallback(
	// 	(_date: Date, name: string) => {
	// 		const date = new Date(_date);
	// 		const parsedDate =
	// 			date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

	// 		setDependent((prev) => {
	// 			const updated = { ...prev, [name]: parsedDate };
	// 			return updated;
	// 		});

	// 		// 🔥 trigger search when DOB changes
	// 		setTimeout(checkPersonExists, 0);
	// 	},
	// 	[checkPersonExists]
	// );

	const DOB = new Date(dependent.date_of_birth);
	const maxEventDateRange = DOB.setDate(DOB.getDate());

	const handleApproveDependent = async (event: React.MouseEvent<HTMLButtonElement>) => {};

	const handleSubmitRedirectRoute = useCallback(() => {
		const pathname = `/employer/member?${routeParam}`;
		navigate(pathname);
	}, []);

	// const handleCreateDependent = useCallback(
	// 	async (event: React.MouseEvent<HTMLButtonElement>) => {
	// 		try {
	// 			event.preventDefault();

	// 			if (isDuplicateBlocking) {
	// 				console.warn("⛔ Blocked: duplicate dependent");
	// 				return;
	// 			}

	// 			let status = await handleValidation();
	// 			if (status === "valid") {
	// 				const { date_of_birth, event_date, event_document } = dependent;
	// 				const DOB = new Date(date_of_birth);
	// 				const eventDate = event_date ? new Date(event_date) : "";
	// 				console.log("dependent=====>", dependent);
	// 				dependent.actual_SSN = dependent["SSN"]
	// 					? dependent["SSN"].replace(/-/g, "")
	// 					: dependent.SSN.replace(/-/g, "");
	// 				dependent.SSN = dependent["alt_id"] ? dependent["alt_id"] : dependent.SSN.replace(/-/g, "");
	// 				delete dependent["alt_id"];
	// 				const payload = {
	// 					employee: {
	// 						...employee,
	// 						employee_SSN: employee?.employee_SSN?.toString().replaceAll("-", "")
	// 					},
	// 					dependent: {
	// 						...dependent,
	// 						date_of_birth: DOB.getFullYear() + "-" + (DOB.getMonth() + 1) + "-" + DOB.getDate(),
	// 						event_date: eventDate
	// 							? eventDate.getFullYear() + "-" + (eventDate.getMonth() + 1) + "-" + eventDate.getDate()
	// 							: "",
	// 						// SSN: dependent?.SSN?.toString().replaceAll("-", ""),
	// 						SSN:
	// 							existMember?.role === "EMPLOYEE" && employee.employee_SSN !== existMember.SSN
	// 								? dependent.SSN.replaceAll("-", "").concat("@")
	// 								: dependent.SSN.replaceAll("-", ""),
	// 						ZIP: dependent.ZIP.replaceAll("-", "")
	// 					}
	// 				};
	// 				// console.log("Payload", payload);
	// 				const formData = new FormData();
	// 				formData.append("event_document_attachment", event_document);
	// 				formData.append("dependent_payload", JSON.stringify(payload));
	// 				const response: any = await trackPromise(api.auth.createDependent(formData));
	// 				// console.log("RESPONSECHECK--->", response);
	// 				if (response) {
	// 					setHasCreateClick(true);
	// 					// console.log("Response", response);
	// 					setDependent(Object.assign({}, response));
	// 					alert("Dependent Created Successfully!");

	// 					// setSnackbarAPICallProps(
	// 					// 	Object.assign({}, snackbarAPICallProps, {
	// 					// 		open: true,
	// 					// 		message: "Dependent created Successfully!",
	// 					// 		severity: "success"
	// 					// 	})
	// 					// );

	// 					// handleSubmitRedirectRoute();
	// 					// setTimeout(() => {
	// 					// 	history.push("/");
	// 					// }, 2000);
	// 					handleSubmitRedirectRoute();

	// 					// setTimeout(() => {
	// 					// 	handleSubmitRedirectRoute();
	// 					// }, 2000);
	// 				}
	// 			} else {
	// 				setHasCreateClick(false);
	// 			}
	// 		} catch (error) {
	// 			setHasCreateClick(false);
	// 			alert("Dependent creation unsuccessful!");
	// 			throw error;
	// 		}
	// 	},
	// 	[dependent, handleValidation]
	// );
	const handleCreateDependent = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();

				// if (isDuplicateBlocking) {
				// 	console.warn(" Blocked: duplicate dependent");
				// 	return;
				// }

				let status = await handleValidation();
				if (status === "valid") {
					const { date_of_birth, event_date, event_document } = dependent;
					const DOB = new Date(date_of_birth);
					const eventDate = event_date ? new Date(event_date) : "";

					// Abhishek(is handling me(@case here)) the SSN value for payload
					let ssnForPayload: string;

					// Priority 1: If we have altIdForPayload (with @ from employee conflict), use it
					if (altIdForPayload && altIdForPayload.endsWith("@")) {
						ssnForPayload = altIdForPayload; // Already has @ suffix
					}
					// Priority 2: If alt_id exists in form, use it (clean version for non-employee conflicts)
					else if (dependent.alt_id) {
						ssnForPayload = dependent.alt_id;
					}
					// Priority 3: Fall back to SSN field
					else {
						ssnForPayload = dependent.SSN?.replace(/-/g, "") || "";
					}

					// Handle actual_SSN (always the clean SSN without @)
					const actualSSN = dependent.SSN?.replace(/-/g, "") || ssnForPayload.replace(/@$/, "");

					const payload = {
						employee: {
							...employee,
							employee_SSN: employee?.employee_SSN?.toString().replaceAll("-", "")
						},
						dependent: {
							...dependent,
							date_of_birth: DOB.getFullYear() + "-" + (DOB.getMonth() + 1) + "-" + DOB.getDate(),
							event_date: eventDate
								? eventDate.getFullYear() + "-" + (eventDate.getMonth() + 1) + "-" + eventDate.getDate()
								: "",
							actual_SSN: actualSSN,
							// SSN field gets the ALT-ID (with @ if employee conversion)
							SSN: ssnForPayload,
							ZIP: dependent.ZIP?.replaceAll("-", "") || ""
						}
					};

					// Remove alt_id from payload since we're using it as SSN
					delete payload.dependent.alt_id;

					console.log("Payload with ALT-ID handling:", payload);

					const formData = new FormData();
					formData.append("event_document_attachment", event_document);
					formData.append("dependent_payload", JSON.stringify(payload));

					const response: any = await trackPromise(api.auth.createDependent(formData));

					if (response) {
						setHasCreateClick(true);
						setDependent(Object.assign({}, response));
						alert("Dependent Created Successfully!");
						handleSubmitRedirectRoute();
					}
				} else {
					setHasCreateClick(false);
				}
			} catch (error) {
				setHasCreateClick(false);
				alert("Dependent creation unsuccessful!");
				throw error;
			}
		},
		[dependent, handleValidation, altIdForPayload, employee, ssnProvidedByGroup, selectedGroup]
	);

	const handleHyphenInZip = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "-") {
			event.preventDefault();
		}
	};

	const handleEnableCheckbox = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, checked } = event.target;
			setDependent(Object.assign({}, dependent, { [name]: checked }));
		},
		[dependent]
	);

	// const getAssignGroups = useCallback(async () => {
	// 	const params = {
	// 		user_id: user?._id
	// 	};
	// 	const response = await api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params);

	// 	if (response) {
	// 		const _assignedGroups: any[] = [];
	// 		response.groupsAndLocations.forEach((group: any) => {
	// 			if (group.assigned_group_info) {
	// 				_assignedGroups.push(group);
	// 			}
	// 		});

	// 		setAssignedGroups(Object.assign([], _assignedGroups));
	// 	}
	// }, [user?._id]);

	// const getSelectedGroup = useCallback(
	// 	async (_group_number: any) => {
	// 		assignedGroups?.forEach((group: any) => {
	// 			if (group.group_number === _group_number) {
	// 				setSelectedGroup(Object.assign({}, group));
	// 			}
	// 		});
	// 	},
	// 	[assignedGroups]
	// );

	// const getSelectedLocation = useCallback(
	// 	async (_location_number: any) => {
	// 		assignedLocations?.forEach((location: any) => {
	// 			if (location.location_number === _location_number) {
	// 				setSelectedLocation(Object.assign({}, location));
	// 			}
	// 		});
	// 	},
	// 	[assignedLocations]
	// );

	const getMembersByEmployeeSSN = useCallback(async (_employee_SSN: string, group_number: number) => {
		const findEmployeeQuery = {
			group_number,
			employee_SSN: _employee_SSN
		};

		const response = await trackPromise(api.member.getMembersByEmployeeSSN(findEmployeeQuery));

		if (response) {
			// console.log("Members: ", response);
			const { memberInstance } = response;

			memberInstance.forEach((member: MemberTypes) => {
				const { role } = member;

				if (role === ROLES.employee) {
					const {
						member_id,
						employee_SSN,
						group_number,
						location_number,
						first_name,
						last_name,
						contact_label,
						phone_extension,
						phone_number,
						address_line_1,
						address_line_2,
						city,
						state,
						ZIP
					} = member;

					// Fetching Group and Location
					getGroupAndLocation(group_number, location_number);

					// Converting SSN to required type
					const ssn = String(employee_SSN);
					let _employee_SSN = ssn.substring(0, 3) + "-" + ssn.substring(3, 5) + "-" + ssn.substring(5);

					setEmployee(
						Object.assign({}, employee, {
							member_id,
							employee_SSN: _employee_SSN,
							group_number,
							location_number,
							first_name,
							last_name
						})
					);

					// Converting ZIP into required format
					let _ZIP = String(member.ZIP);
					if (_ZIP.length > 5) _ZIP = ZIP?.substring(0, 5) + "-" + ZIP?.substring(5);

					const _dependent: any = {
						...dependent,
						contact_label: member.contact_label,
						phone_extension: member.phone_extension,
						phone_number: member.phone_number,
						address_line_1: member.address_line_1,
						address_line_2: member.address_line_2,
						city: member.city,
						state: member.state,
						ZIP: _ZIP
					};

					// console.log("dependent payload loaded", _dependent);

					setDependent(Object.assign({}, _dependent));
				}
				if (role === ROLES.dependent) {
					const { relationship } = member;

					if (relationship === RELATIONSHIP.spouse) {
						setHasSpouse(true);
					}
				}
			});
		}
	}, []);

	const getGroupAndLocation = useCallback(
		async (group_number: number | null | undefined, location_number: number | null | undefined) => {
			const query = {
				group_number,
				location_number
			};

			const response = await trackPromise(api.group.getGroupAndLocation(query));

			// console.log("Group and Location", response);

			const { groupInstance, locationInstance } = response;

			setSelectedGroup(Object.assign({}, groupInstance));
			setSelectedLocation(Object.assign({}, locationInstance));
		},
		[]
	);
	const handleClose = () => setIsModalOpen(false);
	const handleConfirm = () => {
		// Close the modal
		handleClose();
	};

	const handleGenerateAltId = async () => {
		try {
			const getAlternateIDQuery = {
				group_number: queryGroupNumber,
				first_name: dependent.first_name,
				last_name: dependent.last_name,
				date_of_birth: dependent.date_of_birth
			};

			const response: any = await trackPromise(api.alternateID.getAlternateID(getAlternateIDQuery as any));
			console.log("alternateIDResponse=====>", response);

			if (response?.exists === true) {
				const existingMember = response.member;
				const altId = response.alternate_ID;

				// Check if existing member is an EMPLOYEE
				if (existingMember?.role === "EMPLOYEE") {
					// Store the ALT-ID with @ suffix for payload use only (not UI)
					const altIdWithSuffix = altId + "@";
					setAltIdForPayload(altIdWithSuffix);

					// Store member data for the modal
					setIdentityConflictMemberData({
						first_name: existingMember.first_name,
						last_name: existingMember.last_name,
						date_of_birth: dependent.date_of_birth,
						role: existingMember.role,
						relationship: dependent.relationship,
						_id: existingMember._id,
						id: existingMember.id,
						alt_id: altId // Clean version without @
					});

					// Set the clean alt_id in form (WITHOUT @ - user sees clean version)
					handleDependentChange({
						target: {
							name: "alt_id",
							value: altId
						}
					} as React.ChangeEvent<HTMLInputElement>);

					// Open the identity conflict modal
					setShowIdentityConflictModal(true);
					return;
				}

				// If exists but not an employee, show the regular alt ID exists modal
				setExistingAltId(altId);
				setAltIdModalOpen(true);

				// Auto-assign the clean value to the form
				handleDependentChange({
					target: {
						name: "alt_id",
						value: altId
					}
				} as React.ChangeEvent<HTMLInputElement>);

				return;
			}

			// No conflict - generate new ALT ID
			if (response?.alternate_ID) {
				// Clear any previous payload override
				setAltIdForPayload("");

				handleDependentChange({
					target: {
						name: "alt_id",
						value: response.alternate_ID
					}
				} as React.ChangeEvent<HTMLInputElement>);

				setSnackbarAPICallProps(
					Object.assign({}, snackbarAPICallProps, {
						open: true,
						message: "New Alternate ID generated successfully!",
						severity: "success"
					})
				);
			}
		} catch (error: any) {
			console.error("Error generating ALT ID:", error);
		}
	};
	// const handleGenerateAltId = async () => {
	// 	try {
	// 		// if (!employee.member_id) {
	// 		// 	alert("Please enter Employee ID first");
	// 		// 	return;
	// 		// }

	// 		// if (!dependent.relationship) {
	// 		// 	alert("please select relationship first");
	// 		// 	return;
	// 		// }

	// 		const getAlternateIDQuery = {
	// 			group_number: queryGroupNumber,
	// 			first_name: dependent.first_name,
	// 			last_name: dependent.last_name,
	// 			date_of_birth: dependent.date_of_birth,
	// 		};

	// 		const response: any = await trackPromise(api.alternateID.getAlternateID(getAlternateIDQuery as any));
	// 		console.log("alternateIDResponse=====>", response);

	// 		if (response?.exists === true) {
	// 			const existingMember = response.member;
	// 			const altId = response.alternate_ID;

	// 			// Check if existing member is an EMPLOYEE
	// 			if (existingMember?.role === "EMPLOYEE") {
	// 				// Store the ALT-ID with @ suffix for payload use only (not UI)
	// 				const altIdWithSuffix = altId + "@";
	// 				setAltIdForPayload(altIdWithSuffix);

	// 				// Store member data for the modal
	// 				setIdentityConflictMemberData({
	// 					first_name: existingMember.first_name,
	// 					last_name: existingMember.last_name,
	// 					date_of_birth: dependent.date_of_birth,
	// 					role: existingMember.role,
	// 					relationship: dependent.relationship,
	// 					_id: existingMember._id,
	// 					id: existingMember.id,
	// 					alt_id: altId // Clean version without @
	// 				});

	// 				// Set the clean alt_id in form (WITHOUT @ - user sees clean version)
	// 				handleDependentChange({
	// 					target: {
	// 						name: "alt_id",
	// 						value: altId
	// 					}
	// 				} as React.ChangeEvent<HTMLInputElement>);

	// 				// Open the identity conflict modal
	// 				setShowIdentityConflictModal(true);
	// 				return;
	// 			}

	// 			// If exists but not an employee, show the regular alt ID exists modal
	// 			setExistingAltId(altId);
	// 			setAltIdModalOpen(true);

	// 			// Auto-assign the clean value to the form
	// 			handleDependentChange({
	// 				target: {
	// 					name: "alt_id",
	// 					value: altId
	// 				}
	// 			} as React.ChangeEvent<HTMLInputElement>);

	// 			return;
	// 		}

	// 		// No conflict - generate new ALT ID
	// 		if (response?.alternate_ID) {
	// 			// Clear any previous payload override
	// 			setAltIdForPayload("");

	// 			handleDependentChange({
	// 				target: {
	// 					name: "alt_id",
	// 					value: response.alternate_ID
	// 				}
	// 			} as React.ChangeEvent<HTMLInputElement>);

	// 			setSnackbarAPICallProps(
	// 				Object.assign({}, snackbarAPICallProps, {
	// 					open: true,
	// 					message: "New Alternate ID generated successfully!",
	// 					severity: "success"
	// 				})
	// 			);
	// 		}
	// 	} catch (error: any) {
	// 		console.error("Error generating ALT ID:", error);
	// 	}
	// };

	const handleIdentityConflictConfirm = () => {
		// The alt_id with @ suffix is already set in the form
		// Close the modal and proceed with form submission
		setShowIdentityConflictModal(false);

		// Optionally auto-submit or just let user click Create Dependent
		// handleCreateDependent({ preventDefault: () => {} } as any);
	};

	useEffect(() => {
		if (isView) {
			setDashboardHeader(ADMIN_DASHBOARD_HEADER.approve_dependent);
		} else {
			setDashboardHeader(ADMIN_DASHBOARD_HEADER.create_dependent);
		}
	}, [setDashboardHeader, isView]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) getMembersByEmployeeSSN(querySSN as string, queryGroupNumber as number);
	}, [getMembersByEmployeeSSN, querySSN, queryGroupNumber]);

	useEffect(() => {
		if (existMember?.role === "EMPLOYEE" && formatSSN(employee.employee_SSN) === existMember.SSN) {
			setShowModal(true);
			setOwnSSNCheck(true);
		} else {
			setOwnSSNCheck(false);
		}
	}, [existMember, employee.employee_SSN]);

	// useEffect(() => {
	// 	getSelectedGroup(employee.group_number);
	// }, [getSelectedGroup]);

	// useEffect(() => {
	// 	setAssignedLocations(Object.assign([], selectedGroup?.assigned_locations));
	// }, [selectedGroup]);

	// useEffect(() => {
	// 	getSelectedLocation(employee.location_number);
	// }, [getSelectedLocation]);

	// console.log("Selected Groups", selectedGroup);
	// console.log("Assigned Locations", assignedLocations);

	// useEffect(() => {
	// 	if (query) {
	// 		const _isValidEmployeeId = query.get("employee_number") ? true : false;
	// 		if (_isValidEmployeeId) {
	// 			const _dependent = {
	// 				...dependent,
	// 				employee_number: Number(query.get("employee_number"))
	// 			};
	// 			console.log(_dependent.employee_number);
	// 			setDependent(Object.assign({}, _dependent));

	// 			// setIsValidEmployeeId(true);
	// 		} else {
	// 			// setIsValidEmployeeId(false);
	// 			alert("Invalid Employee Number!");
	// 			navigate("/groups/employees");
	// 		}
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [query]);

	// useEffect(() => {
	// 	if (location.pathname === "/groups/view-dependent") {
	// 		setIsView(true);
	// 	} else {
	// 		setIsView(false);
	// 	}
	// }, [isView, location.pathname]);

	useEffect(() => {
		if (!selectedGroup) return;
		setDependentForm(
			Object.assign(
				{},
				{
					"Employee Profile Information": [
						{
							schema: "employee",
							label: "Group",
							name: "group_number",
							onChange: () => null,
							value: employee.group_number,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "Location",
							name: "location_number",
							onChange: () => null,
							value: employee.location_number,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "Employee Id",
							name: "member_id",
							onChange: () => null,
							value: employee.member_id,
							type: "textfield"
						},
						{
							schema: "employee",
							// label: "Employee ALT-ID",
							label: "Employee SSN",
							name: "employee_SSN",
							onChange: () => null,
							value: employee.employee_SSN,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "First Name",
							name: "first_name",
							onChange: () => null,
							value: employee.first_name,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "Last Name",
							name: "last_name",
							onChange: () => null,
							value: employee.last_name,
							type: "textfield"
						}
					],
					"Family Member Information": [
						{
							schema: "dependent",
							label: "First Name",
							name: "first_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter dependent first name",
							value: dependent.first_name,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "Middle Name",
							name: "middle_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter dependent middle name",
							value: dependent.middle_name,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "Last Name",
							name: "last_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter dependent last name",
							value: dependent.last_name,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "Date of Birth",
							name: "date_of_birth",
							onChange: (date: Date, name: string) => handleDependentDateChange(date, name),
							placeholder: "Enter date of birth",
							value: dependent.date_of_birth,
							type: "date"
						},

						// ...(selectedGroup?.SSN_provided_by_group === true
						// 	? [
						// 		{
						// 			schema: "dependent",
						// 			label: "SSN",
						// 			name: "SSN",
						// 			onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
						// 				handleDependentChange(event),
						// 			placeholder: "Enter dependent SSN",
						// 			value: dependent.SSN,
						// 			type: "textfield"
						// 		},
						// 		{
						// 			schema: "dependent",
						// 			label: "Re-Enter SSN",
						// 			name: "re_enter_SSN",
						// 			onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
						// 				handleReEnterSSNChange(event),
						// 			placeholder: "Re-Enter SSN",
						// 			value: reEnterSSN,
						// 			type: "textfield"
						// 		}
						// 	]
						// 	: []),
						...(ssnProvidedByGroup || selectedGroup?.SSN_provided_by_group === true
							? [
									{
										schema: "dependent",
										label: "SSN",
										name: "SSN",
										onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
											handleDependentChange(event),
										placeholder: "Enter dependent SSN",
										value: dependent.SSN,
										type: "textfield",
										controlled: true,
										required: true
									},
									{
										schema: "dependent",
										label: "Re-Enter SSN",
										name: "re_enter_SSN",
										onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
											handleReEnterSSNChange(event),
										placeholder: "Re-Enter SSN",
										value: reEnterSSN,
										type: "textfield",
										controlled: true,
										required: true
									}
							  ]
							: []),
						...(ssnProvidedByGroup || selectedGroup?.SSN_provided_by_group === true
							? [] // Don't show ALT ID when SSN is required
							: [
									{
										schema: "dependent",
										// label: "ALT-ID",
										label: "SSN",
										name: "alt_id",
										onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
											handleDependentChange(event),
										placeholder: "Enter SSN",
										value: dependent.alt_id,
										type: "textfield",
										controlled: true,
										showGenerateAltId: true
									}
							  ]),

						{
							schema: "dependent",
							label: "Email",
							name: "email",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter email",
							value: dependent.email,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "Gender",
							name: "gender",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter gender",
							value: dependent.gender,
							type: "select",
							options: GENDERS
						},
						{
							schema: "dependent",
							label: "Dependent Type",
							name: "dependent_type",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter dependent type",
							value: dependent.dependent_type,
							type: "select",
							options: DEPENDENT_TYPES
						},
						{
							schema: "dependent",
							label: "Relationship",
							name: "relationship",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter relationship type",
							value: dependent.relationship,
							type: "select",
							options: RELATIONSHIPS
						},
						{
							label: "Disabled",
							name: "is_disabled",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
							value: dependent.is_disabled,
							type: "checkbox"
						},
						{
							label: "Tobacco",
							name: "is_tobacco",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
							value: dependent.is_tobacco,
							type: "checkbox"
						},
						{
							label: "Dependent Profile Access",
							name: "dependent_profile_access",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
							value: dependent.dependent_profile_access,
							type: "checkbox"
						}
					],
					"Family Contact Information": [
						{
							schema: "dependent",
							label: "Contact Label",
							name: "contact_label",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							value: dependent.contact_label,
							type: "select",
							options: CONTACT_LABELS
						},
						{
							schema: "dependent",
							label: "Phone Number",
							name: "phone_number",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter phone number",
							value: dependent.phone_number,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "Phone Extension",
							name: "phone_extension",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter phone extension",
							value: dependent.phone_extension,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "Address Line 1",
							name: "address_line_1",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter address 1",
							value: dependent.address_line_1,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "Address Line 2",
							name: "address_line_2",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter address 2",
							value: dependent.address_line_2,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "City",
							name: "city",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter city",
							value: dependent.city,
							type: "textfield",
							controlled: false
						},
						{
							schema: "dependent",
							label: "State",
							name: "state",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							value: dependent.state,
							type: "select",
							options: STATES
						},
						{
							schema: "dependent",
							label: "Country",
							name: "country",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter country",
							value: "USA - United States of America",
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "ZIP Code",
							name: "ZIP",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDependentChange(event),
							placeholder: "Enter ZIP",
							value: dependent.ZIP,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Event Date",
							name: "event_date",
							onChange: (date: Date, name: string) => handleDependentDateChange(date, name),
							placeholder: "Enter event date",
							value: dependent.event_date,
							type: "date"
						},
						{
							schema: "dependent",
							label: "Event Name",
							name: "event_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
								if (dependent.relationship === null) {
									event.target.value = "";
									alert("Please select relationship first!");
									return;
								} else {
									handleDependentChange(event);
								}
							},
							placeholder: "Enter event name",
							value: dependent.event_name,
							type: "select",
							options:
								dependent.relationship === RELATIONSHIP.spouse
									? [EVENT_NAME.marriage]
									: dependent.relationship === RELATIONSHIP.child ||
									  dependent.relationship === RELATIONSHIP.grandchild
									? [EVENT_NAME.birth_of_baby]
									: dependent.relationship === RELATIONSHIP.stepchild ||
									  dependent.relationship === RELATIONSHIP.disabled_child ||
									  dependent.relationship === RELATIONSHIP.legal_custody_child ||
									  dependent.relationship === RELATIONSHIP.court_ordered_dependent
									? [EVENT_NAME.adoption, EVENT_NAME.others]
									: EVENT_NAMES
						},
						{
							schema: "dependent",
							label: "Event Document",
							name: "event_document",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleDocumentChange(event),
							value: dependent.event_document,
							type: "file"
						}
					]
				}
			)
		);
	}, [
		employee,
		dependent,
		handleDependentChange,
		handleDependentDateChange,
		handleDocumentChange,
		reEnterSSN,
		handleReEnterSSNChange,
		selectedGroup,
		ssnProvidedByGroup
	]);

	// format EmployeeSSN--->
	const formatSSN = (employeeSSN: any) => {
		return employeeSSN.replace(/-/g, "");
	};

	// useEffect(() => {
	// 	setDuplicateMode("NONE");
	// }, [
	// 	dependent.first_name,
	// 	dependent.last_name,
	// 	dependent.date_of_birth,
	// 	employee.employee_SSN
	// ]);

	// console.log("🧪 duplicateMode:", duplicateMode);

	// console.log("consoleforthecheck------>", formatSSN(employee.employee_SSN), existMember?.SSN);
	return (
		<>
			<div className="create-dependent" id="create-dependent">
				<Suspense fallback={<div />}>
					<SnackbarAPI snackbarProps={snackbarAPICallProps} />
				</Suspense>
				{isValidEmployeeId ? (
					<>
						<div className="pf-action-button-container" id="pf-action-button-container">
							{isView ? (
								<Button
									className="button-green"
									onClick={handleApproveDependent}
									variant="contained"
									disabled={hasCreateClick}
									disableElevation={hasCreateClick}
									style={{
										cursor: hasCreateClick ? "not-allowed" : "pointer",
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Approve Dependent</span>
									<span>
										<CheckCircleOutlineIcon className="button-icon" />
									</span>
								</Button>
							) : (
								<Button
									className="button-green"
									onClick={handleCreateDependent}
									variant="contained"
									disabled={ownSSNCheck || hasCreateClick}
									disableElevation={hasCreateClick}
									style={{
										cursor: ownSSNCheck || hasCreateClick ? "not-allowed" : "pointer",
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Create Dependent</span>
									<span>
										<WcIcon className="button-icon" />
									</span>
								</Button>
							)}
						</div>
						<Grid container spacing={1} className="pf-grid-container">
							{dependentForm &&
								Object.entries(dependentForm).map(([key, value]: any, index) => {
									return (
										<div key={index}>
											<div className="pf-title">{key}</div>
											<Suspense fallback={<div />}>
												<Paper className="pf-paper-container" elevation={3} variant="outlined">
													{value.map((field: DynamicFormField, index: number) => {
														return (
															<Grid
																key={index}
																item
																xl={12}
																lg={12}
																md={12}
																sm={12}
																xs={12}
															>
																<Grid container spacing={1} className="pf-label">
																	<Grid
																		item
																		xs={
																			field.name === "is_tobacco" ||
																			field.name === "is_disabled" ||
																			field.name === "dependent_profile_access"
																				? undefined
																				: 12
																		}
																		sm={
																			field.name === "is_tobacco" ||
																			field.name === "is_disabled" ||
																			field.name === "dependent_profile_access"
																				? undefined
																				: 12
																		}
																		md={
																			field.name === "is_tobacco" ||
																			field.name === "is_disabled" ||
																			field.name === "dependent_profile_access"
																				? undefined
																				: 3
																		}
																		lg={
																			field.name === "is_tobacco" ||
																			field.name === "is_disabled" ||
																			field.name === "dependent_profile_access"
																				? undefined
																				: 3
																		}
																		xl={
																			field.name === "is_tobacco" ||
																			field.name === "is_disabled" ||
																			field.name === "dependent_profile_access"
																				? undefined
																				: 3
																		}
																	>
																		<div
																			className={
																				field.name === "middle_name" ||
																				field.name === "email" ||
																				field.name === "phone_number" ||
																				field.name === "phone_extension" ||
																				field.name === "address_line_2" ||
																				field.name === "is_tobacco" ||
																				field.name === "is_disabled" ||
																				field.name ===
																					"dependent_profile_access" ||
																				field.name === "event_name" ||
																				field.name === "event_date" ||
																				field.name === "event_document"
																					? "pf-label-text"
																					: "pf-label-text required"
																			}
																			id="pf-label-text"
																		>
																			{field.name === "is_tobacco" ||
																			field.name === "is_disabled" ||
																			field.name === "dependent_profile_access"
																				? ""
																				: field.label}
																		</div>
																	</Grid>
																	<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
																		{field.type === "textfield" ? (
																			field.name === "alt_id" &&
																			(field as any).showGenerateAltId ? (
																				<Grid
																					container
																					spacing={1}
																					alignItems="center"
																				>
																					<Grid item>
																						<TextField
																							className="text-field"
																							id="input-text-field"
																							name={field.name}
																							placeholder={
																								field.placeholder
																							}
																							value={field.value}
																							onChange={field.onChange}
																							variant="outlined"
																							helperText={
																								validation.dependent
																									?.alt_id
																							}
																							style={{ width: "340px" }}
																						/>
																					</Grid>

																					<Grid item xs={4}>
																						<div
																							style={{
																								position: "relative",
																								display: "inline-block",
																								width: "100%"
																							}}
																							onMouseEnter={() => {
																								if (
																									!dependent.first_name ||
																									!dependent.last_name ||
																									!dependent.date_of_birth
																								) {
																									setShowTooltip(
																										true
																									);
																								}
																							}}
																							onMouseLeave={() =>
																								setShowTooltip(false)
																							}
																						>
																							<Button
																								variant={
																									field.value
																										? "outlined"
																										: "contained"
																								}
																								color="primary"
																								onClick={
																									handleGenerateAltId
																								}
																								disabled={
																									Boolean(
																										field.value
																									) ||
																									!dependent.first_name ||
																									!dependent.last_name ||
																									!dependent.date_of_birth
																								}
																								style={{
																									height: 36,
																									textTransform:
																										"none",
																									fontWeight: 500,
																									fontSize: "0.8rem",
																									boxShadow:
																										field.value
																											? "none"
																											: "0 1px 2px rgba(0,0,0,0.15)",
																									backgroundColor:
																										field.value
																											? "transparent"
																											: "#2e7d32",
																									color: field.value
																										? "#2e7d32"
																										: "#fff",
																									borderColor:
																										"#2e7d32",
																									borderWidth: 1.5,
																									cursor:
																										Boolean(
																											field.value
																										) ||
																										!dependent.first_name ||
																										!dependent.last_name ||
																										!dependent.date_of_birth
																											? "not-allowed"
																											: "pointer",
																									opacity:
																										Boolean(
																											field.value
																										) ||
																										!dependent.first_name ||
																										!dependent.last_name ||
																										!dependent.date_of_birth
																											? 0.7
																											: 1
																								}}
																								startIcon={
																									<AssignmentIndIcon />
																								}
																							>
																								{field.value
																									? "ID Assigned"
																									: // : "Generate ALT ID"
																									  "Generate SSN"}
																							</Button>

																							{/* Tooltip for missing required fields */}
																							{showTooltip &&
																								!field.value &&
																								(!dependent.first_name ||
																									!dependent.last_name ||
																									!dependent.date_of_birth) && (
																									<div
																										style={{
																											position:
																												"absolute",
																											bottom: "100%",
																											left: "20%",
																											transform:
																												"translateX(-50%)",
																											marginBottom:
																												"8px",
																											padding:
																												"8px 12px",
																											backgroundColor:
																												"#374151",
																											color: "#fff",
																											fontSize:
																												"0.75rem",
																											borderRadius:
																												"6px",
																											whiteSpace:
																												"nowrap",
																											zIndex: 1000,
																											boxShadow:
																												"0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
																											animation:
																												"fadeIn 0.2s ease-in-out"
																										}}
																									>
																										<span
																											style={{
																												fontWeight: 600
																											}}
																										>
																											Please fill
																											in:
																										</span>
																										<ul
																											style={{
																												margin: "4px 0 0 0",
																												paddingLeft:
																													"16px",
																												listStyle:
																													"disc",
																												lineHeight:
																													"1.5"
																											}}
																										>
																											{!dependent.first_name && (
																												<li>
																													First
																													Name
																												</li>
																											)}
																											{!dependent.last_name && (
																												<li>
																													Last
																													Name
																												</li>
																											)}
																											{!dependent.date_of_birth && (
																												<li>
																													Date
																													of
																													Birth
																												</li>
																											)}
																										</ul>

																										{/* Tooltip Arrow */}
																										<div
																											style={{
																												position:
																													"absolute",
																												top: "100%",
																												left: "50%",
																												transform:
																													"translateX(-50%)",
																												borderWidth:
																													"6px",
																												borderStyle:
																													"solid",
																												borderColor:
																													"#374151 transparent transparent transparent"
																											}}
																										/>
																									</div>
																								)}
																						</div>
																					</Grid>
																				</Grid>
																			) : (
																				<TextField
																					className="text-field"
																					id={
																						field.name === "country" ||
																						field.schema === "employee"
																							? "disabled-input-text-field"
																							: "input-text-field"
																					}
																					name={field.name}
																					placeholder={field.placeholder}
																					value={
																						field.schema === "dependent"
																							? field.name ===
																							  "group_number"
																								? selectedGroup?.name
																								: field.name ===
																								  "location_number"
																								? selectedLocation?.location_name
																								: field.value
																							: field.controlled === false
																							? undefined
																							: field.value
																					}
																					onChange={field.onChange}
																					//onBlur={field.onBlur}
																					onKeyDown={(event) =>
																						handleKeyCheck(event)
																					}
																					onPaste={(event) =>
																						handlePaste(event)
																					}
																					variant="outlined"
																					inputProps={{
																						onKeyDown:
																							field.name === "ZIP"
																								? handleHyphenInZip
																								: undefined
																					}}
																					InputProps={{
																						readOnly:
																							field.schema === "employee"
																								? true
																								: isView
																					}}
																					//style={{ width: "70%", borderRadius: 50 }}
																					//disabled={!isButtonSelected}
																					//disableElevation={!isButtonSelected}
																					style={{
																						width: "340px",
																						borderRadius: 50
																					}}
																					disabled={
																						field.name === "country" ||
																						field.schema === "employee"
																							? true
																							: false
																					}
																					helperText={
																						field.schema === "dependent"
																							? field.name === "SSN" &&
																							  SSNExists
																								? formatSSN(
																										employee.employee_SSN
																								  ) === existMember?.SSN
																									? "You are entering your own SSN"
																									: "SSN already exists"
																								: field.name === "email"
																								? emailExists
																									? "Email exists!"
																									: checkInvalidEmail
																									? "Please enter a valid email address!"
																									: validation
																											.dependent[
																											field.name
																									  ]
																								: field.name ===
																								  "re_enter_SSN"
																								? validation.reEnterSSN
																								: validation.dependent[
																										field.name
																								  ]
																							: ""
																					}

																					// helperText={
																					// 	field.name === "SSN" && SSNExists
																					// 		? existMember?.role === "DEPENDENT"
																					// 			? "SSN already exists!"
																					// 			: "SSN already exists as an employee"
																					// 		: ""
																					// }
																				/>
																			)
																		) : field.type === "select" ? (
																			<>
																				<Select
																					id="text-align-options"
																					name={field.name}
																					value={field.value}
																					onChange={field.onChange}
																					//disabled={!isButtonSelected}
																					//disableElevation={!isButtonSelected}
																					style={{
																						//cursor: !isButtonSelected ? "not-allowed" : "pointer",
																						pointerEvents: "unset",
																						minWidth: 180,
																						textAlign: "left",
																						// zIndex: 10000,
																						overflowY: "visible"
																					}}
																					MenuProps={{
																						style: { zIndex: 35960 }
																					}}
																					inputProps={{
																						"aria-label": "Without label",
																						readOnly: isView
																					}}
																				>
																					<MenuItem value="" disabled>
																						Select Value
																					</MenuItem>
																					{field.options?.map(
																						(option: string) =>
																							option ===
																								RELATIONSHIP.spouse &&
																							hasSpouse ? (
																								<MenuItem
																									key={option}
																									value={
																										field.name ===
																											"event_name" &&
																										dependent.relationship ===
																											""
																											? ""
																											: option
																									}
																									disabled
																								>
																									{field.name ===
																									"gender"
																										? initCapitalize(
																												option
																										  )
																										: field.name ===
																										  "relationship"
																										? initCapitalize(
																												option
																										  )
																										: field.name ===
																										  "contact_label"
																										? initCapitalize(
																												option
																										  )
																										: field.name ===
																										  "event_name"
																										? initCapitalize(
																												option
																										  )
																										: option}
																								</MenuItem>
																							) : (
																								<MenuItem
																									key={option}
																									value={
																										field.name ===
																											"event_name" &&
																										dependent.relationship ===
																											null
																											? ""
																											: option
																									}
																								>
																									{field.name ===
																									"gender"
																										? initCapitalize(
																												option
																										  )
																										: field.name ===
																										  "relationship"
																										? initCapitalize(
																												option
																										  )
																										: field.name ===
																										  "contact_label"
																										? initCapitalize(
																												option
																										  )
																										: field.name ===
																										  "event_name"
																										? initCapitalize(
																												option
																										  )
																										: option}
																								</MenuItem>
																							)
																					)}
																				</Select>
																				{validation &&
																				validation.dependent[field.name] ? (
																					<div className="details">
																						<span className="select-validation-text2">
																							{field.schema ===
																							"dependent"
																								? validation.dependent[
																										field.name
																								  ]
																								: ""}
																						</span>
																					</div>
																				) : null}
																			</>
																		) : field.type === "date" ? (
																			<MuiPickersUtilsProvider
																				utils={DateFnsUtils}
																			>
																				<KeyboardDatePicker
																					className="from-date-input"
																					id="from-date-input"
																					inputVariant="outlined"
																					//label={field.label}
																					placeholder={field.placeholder}
																					name={field.name}
																					format="MM/dd/yyyy"
																					error={false}
																					value={field.value}
																					readOnly={isView}
																					onChange={(date) =>
																						field.onChange(date, field.name)
																					}
																					maxDate={
																						field.name ===
																							"date_of_birth" ||
																						(field.name === "event_date" &&
																							String(
																								dependent.date_of_birth
																							).length === 0)
																							? maxDateRange
																							: field.name ===
																									"event_date" &&
																							  String(
																									dependent.date_of_birth
																							  ).length !== 0
																							? maxEventDateRange
																							: undefined
																					}
																					InputProps={{
																						readOnly: true
																					}}
																					InputLabelProps={{
																						shrink: true
																					}}
																					//style={{ width: "340px", borderRadius: 50 }}
																					keyboardIcon={
																						<EventIcon
																							style={{ color: "#7cb342" }}
																						/>
																					}
																					KeyboardButtonProps={{
																						"aria-label": "change date"
																					}}
																					// disabled={!isButtonSelected}
																					// disableElevation={!isButtonSelected}
																					style={{
																						// cursor: !isButtonSelected ? "not-allowed" : "pointer",
																						pointerEvents: "unset",
																						width: "340px",
																						borderRadius: 50
																					}}
																					helperText={
																						field.schema === "dependent"
																							? validation.dependent[
																									field.name
																							  ]
																							: ""
																					}
																				/>
																			</MuiPickersUtilsProvider>
																		) : field.type === "checkbox" ? (
																			<>
																				<div
																					className="check-support"
																					id="check-support"
																				>
																					<span>
																						<GreenCheckbox
																							onChange={field.onChange}
																							name={field.name}
																							checked={field.value}
																						/>
																					</span>
																					<span
																						className="pf-label-text"
																						id="pf-label-text"
																					>
																						{field.label}
																					</span>
																				</div>
																			</>
																		) : field.type === "file" &&
																		  field.value === null ? (
																			<>
																				<input
																					className={"document-upload"}
																					id={"document-upload"}
																					name={field.name}
																					type="file"
																					onChange={handleDocumentChange}
																					style={{ display: "none" }}
																					accept="image/*, .pdf"
																				/>
																				<label htmlFor={"document-upload"}>
																					<Button
																						className="button"
																						component="span"
																						variant="contained"
																						style={{
																							backgroundColor: "#3A4652",
																							color: "#ffff",
																							width: 210
																						}}
																					>
																						<span
																							className="button-label-with-icon"
																							style={{ color: "#ffff" }}
																						>
																							{field.label}
																						</span>
																						<span>
																							<PublishIcon
																								className="button-icon"
																								style={{
																									color: "#ffff"
																								}}
																							/>
																						</span>
																					</Button>
																					{validation &&
																					validation.dependent[field.name] ? (
																						<div
																							className="details"
																							style={{
																								paddingLeft: "12.7"
																							}}
																						>
																							<span className="select-validation-text">
																								{field.schema ===
																								"dependent"
																									? validation
																											.dependent[
																											field.name
																									  ]
																									: ""}
																							</span>
																						</div>
																					) : null}
																				</label>
																			</>
																		) : (
																			<Grid
																				item
																				className="chipset"
																				xl={4}
																				lg={4}
																				md={12}
																				sm={12}
																				xs={12}
																			>
																				{field.value ? (
																					<Tooltip
																						title={"Click to download"}
																						arrow
																					>
																						<Chip
																							label={
																								field.value
																									? shortenFileName(
																											field.value
																												.name
																									  )
																									: "No files added"
																							}
																							onDelete={() =>
																								isView
																									? true
																									: handleDeleteDocument()
																							}
																							onClick={() =>
																								downloadFile(
																									field.value
																								)
																							}
																						/>
																					</Tooltip>
																				) : null}
																			</Grid>
																		)}
																	</Grid>
																</Grid>
															</Grid>
														);
													})}
												</Paper>
											</Suspense>
										</div>
									);
								})}
						</Grid>
						<div
							className="pf-action-button-container margin-top-action-button"
							id="pf-action-button-container"
						>
							{isView ? (
								<Button
									className="button-green"
									onClick={handleApproveDependent}
									variant="contained"
									disabled={hasCreateClick}
									disableElevation={hasCreateClick}
									style={{
										cursor: hasCreateClick ? "not-allowed" : "pointer",
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Approve Dependent</span>
									<span>
										<CheckCircleOutlineIcon className="button-icon" />
									</span>
								</Button>
							) : (
								<Button
									className="button-green"
									onClick={handleCreateDependent}
									variant="contained"
									disabled={ownSSNCheck || hasCreateClick}
									disableElevation={hasCreateClick}
									style={{
										cursor: ownSSNCheck || hasCreateClick ? "not-allowed" : "pointer",
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Create Dependent</span>
									<span>
										<WcIcon className="button-icon" />
									</span>
								</Button>
							)}
						</div>
					</>
				) : null}
			</div>

			{SSNExists && existMember?.role === "EMPLOYEE" && formatSSN(employee.employee_SSN) !== existMember.SSN && (
				<IdentityPersonConversionExistsModal
					open={true}
					onClose={() => {
						setIsModalOpen(false);
						setSSNExists(false);
						setExistMember(undefined);
						handleDependentChange({
							target: { name: "SSN", value: "" }
						} as React.ChangeEvent<HTMLInputElement>);
					}}
					onConfirm={() => {
						const ssnWithSuffix = dependent.SSN.replace(/-/g, "") + "@";
						setAltIdForPayload(ssnWithSuffix);
						setIsModalOpen(false);
						setSSNExists(false);
					}}
					memberData={{
						first_name: existMember?.first_name,
						last_name: existMember?.last_name,
						date_of_birth: existMember?.date_of_birth,
						role: existMember?.role,
						SSN: dependent.SSN
					}}
					isSSN={true}
					idValue={dependent.SSN}
				/>
			)}

			{/* <AltIdExistsModal
				open={altIdModalOpen}
				onClose={() => {
					setAltIdModalOpen(false);
					setExistingAltId("");
					// Clear the alt_id field so user can try again or generate new
					handleDependentChange({
						target: {
							name: "alt_id",
							value: ""
						}
					} as React.ChangeEvent<HTMLInputElement>);
				}}
				onConfirm={() => {
					setAltIdModalOpen(false);
					// The ID is already assigned, just close the modal
				}}
				altId={existingAltId}
				employeeName={`${dependent.first_name} ${dependent.last_name}`.trim()}
			/> */}
			{existDependentAllowingModalOpen && (
				<ExistDependentAllowingModal
					onClose={() => {
						setExistDependentAllowingModalOpen(false);
						setExistingDependentForAllowing(null);
						// Clear SSN field
						handleDependentChange({
							target: { name: "SSN", value: "" }
						} as React.ChangeEvent<HTMLInputElement>);
					}}
					onConfirm={handleAllowExistingDependent}
					existingAltId={existingDependentForAllowing?.SSN}
					dependentName={`${dependent.first_name} ${dependent.last_name}`.trim()}
					isSSN={true}
					existingMemberData={{
						first_name: existingDependentForAllowing?.first_name,
						last_name: existingDependentForAllowing?.last_name,
						date_of_birth: existingDependentForAllowing?.date_of_birth,
						relationship: existingDependentForAllowing?.relationship
					}}
				/>
			)}

			{/* <AltIdExistsModal
				open={altIdModalOpen}
				onClose={() => setAltIdModalOpen(false)}
				onConfirm={() => {
					setAltIdModalOpen(false);
					// The ID is already assigned, just close the modal
				}}
				altId={existingAltId}
				employeeName={`${employee.first_name} ${employee.last_name}`.trim()}
			/> */}
			<IdentityPersonConversionExistsModal
				open={showIdentityConflictModal}
				onClose={() => {
					setShowIdentityConflictModal(false);
					setAltIdForPayload(""); // Clear the payload override
					// Optionally clear the alt_id from form too
					handleDependentChange({
						target: {
							name: "alt_id",
							value: ""
						}
					} as React.ChangeEvent<HTMLInputElement>);
				}}
				onConfirm={handleIdentityConflictConfirm}
				memberData={identityConflictMemberData}
			/>
		</>
	);
};
export default CreateDependent;
